import { Component, OnInit } from '@angular/core';
import { DistributorService } from '../../services/distributor.service';
import {Dealer, Employee, Course, AvailableCourse, CourseEnrollment} from '../../model/distributor.model';
import {forkJoin} from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.scss']
})
export class EmployeeProfileComponent implements OnInit {

  dealer: Dealer = new Dealer({});
  employee: Employee = new Employee({
    id: '',
    city: '',
    addressLine1: '',
    addressLine2: '',
    contactType: '',
    dealer: new Dealer({

    }),
    email: '',
    firstName: '',
    isActive: true,
    lastName: '',
    phone: '',
    title: '',
    zip: ''
  });
  training: Array<Course> = [];
  availableCourses: Array<AvailableCourse>;
  activeEnrollments: Array<CourseEnrollment>;
  employeeId: string;
  isLoading = true;
  activityText = 'Loading...';
  completionPopupData = {
    title: '',
    visible: false,
    message: ''
  };

  constructor(private svc: DistributorService) {}

  ngOnInit() {
    this.isLoading = true;
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('employeeId')) {
      this.employeeId = urlParams.get('employeeId');
    }
    this.loadData(() => {
      this.isLoading = false;
    });
  }

  loadData(cb) {
    forkJoin(
      this.svc.fetchEmployee(this.employeeId),
      this.svc.fetchTrainingByEmployee(this.employeeId)
    )
      .subscribe(results => {
        this.dealer = results[0].dealer;
        this.employee = results[0];
        this.training = results[1];
        if (cb) {
          cb();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/distributor/containers/employee-profile/employee-profile.component.ts